import { filterNullable } from "@-/com.npmjs.array-utils-ts";
import type { ReferenceGraphemeMorphemeSlice } from "@-/dev.improve.haniverse.lib.morpheme.entities";
import type { MorphemeInfoPanelAccordionSectionDescriptor } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content._components.morpheme-info-panel-accordion";
import { useMorphemeInfoPanelUsageWordsSection } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content.views.sentences.__sections.words";

/** This tab's sections as descriptors; see the dictionary equivalent for why it lives here. */
export function useMorphemeInfoPanelSentencesGraphemeSections({
  graphemeCard,
}: {
  graphemeCard: ReferenceGraphemeMorphemeSlice;
}): MorphemeInfoPanelAccordionSectionDescriptor[] {
  const examples = useMorphemeInfoPanelUsageWordsSection({
    infoBackCardSlice: graphemeCard,
  });
  return filterNullable([examples]);
}
